import { isEqual } from 'lodash-es';

import { bookToEditorFormProperties } from '@editor2/mappers/book';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { type CourseState } from '@editor2/types/courseState';

import { addStatus, removeStatus } from './helpers';

export const updateEditorFormHelper = (state: CourseState, payload) => {
	const initialEditorForm = state.initialCourse.book;
	const updatedEditorForm = { ...state.book, ...payload };

	const attributesEqual = isEqual(
		bookToEditorFormProperties(initialEditorForm),
		bookToEditorFormProperties(updatedEditorForm)
	);

	state.book = updatedEditorForm;
	state.changes.toc = attributesEqual
		? removeStatus(state.changes.toc, ChangesStatus.Modified)
		: addStatus(state.changes.toc, ChangesStatus.Modified);

	return state;
};

export const updateYamlConfigHelper = (state: CourseState, payload) => {
	const initialYamlConfig = state.initialCourse.book.yaml_config;
	const { yamlConfig: updatedYamlConfig } = payload;

	state.book.yaml_config = updatedYamlConfig;
	state.changes.resourceConfig =
		initialYamlConfig === updatedYamlConfig
			? removeStatus(state.changes.resourceConfig, ChangesStatus.Modified)
			: addStatus(state.changes.resourceConfig, ChangesStatus.Modified);

	return state;
};
